import { Injectable } from '@angular/core';
import { CONSTANTS } from 'environments/common';

const LANG_MAP: {[key: string]: string} = {
  es: CONSTANTS.LANG_ES,
  ca: CONSTANTS.LANG_CA,
  en: CONSTANTS.LANG_EN
};

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  resolveInternalLang(shortLang: string | null | undefined): string {
    const normalized = (shortLang || '').trim().toLowerCase();
    if (CONSTANTS.AVAILABLE_LANGS.includes(normalized)) {
      return LANG_MAP[normalized];
    }
    return CONSTANTS.LANG_ES;
  }
}
